@if (infographic) {
  <div class="infographic">
    <div class="img-wrap">
      <img
        [src]="infographic.backgroundImage"
        width="100%"
        id="infographic-image"
        />
      @for (hotspot of infographic.hotspots; track hotspot; let i = $index) {
        <div
          class="hotspot-button"
          [ngStyle]="getButtonStyle(hotspot)"
          (click)="toggleHotspot($event, i)"
          (keyup.enter)="toggleHotspot($event, i)"
          tabindex="0"
          [attr.name]="hotspot.title"
          [attr.aria-label]="hotspot.title"
          [matTooltip]="hotspot.title"
          >
          <i class="fas fa-info"></i>
        </div>
      }
    </div>
  </div>
}
